import { useEffect } from 'react';

import { Box, Grid } from '@mui/material';
import { Formik } from 'formik';

import Loader from 'src/components/Loader/Loader';
import { showErrorToast } from 'src/components/Toasts/toast';
import { useAddPartnerContext } from 'src/contexts/AddPartnerProvider';
import { useAssignOffersProvider } from 'src/contexts/AssignOffersProvider';

import { NavigationButtons } from '../components/NavigationButtons';
import OnlineOffers from '../components/PricingInformation/OnlineOffers/OnlineOffers';
import TerminalOffers from '../components/PricingInformation/TerminalOffers/TerminalOffers';
import TransactionsOffers from '../components/PricingInformation/TransactionsOffers/TransactionsOffers';

export const Step4: React.FC = () => {
    const { addPartner, handleBack, activeStep } = useAddPartnerContext();
    const { fetchPartnerOffers, fetchingOffers } = useAssignOffersProvider();

    // On first mount fetch the offers for the given partner
    useEffect(() => {
        fetchPartnerOffers();
    }, []);

    return (
        <Formik
            initialValues={{
                assignedOffers: [],
                assignedTransactionOffers: [],
            }}
            onSubmit={async ({ assignedOffers, assignedTransactionOffers }) => {
                const assignedTransactionOfferIds = assignedTransactionOffers.map(({ value }) =>
                    typeof value === 'string' ? parseInt(value) : value
                );

                if (!assignedTransactionOffers.length) {
                    showErrorToast('Please assign a Transaction Offer before continuing');
                } else if (!assignedOffers.length) {
                    showErrorToast('Please assign a Terminal or Online Offer before continuing');
                } else {
                    await addPartner(
                        {
                            assignedOffers,
                            assignedTransactionOffers: assignedTransactionOfferIds,
                            step: 4,
                        },
                        activeStep
                    );
                }
            }}
            validateOnChange
            validateOnBlur
            validateOnMount={false}
        >
            {(formikProps) => (
                <Box display="flex" flexDirection="column" gap="24px">
                    {fetchingOffers && <Loader />}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TerminalOffers />
                        </Grid>
                        <Grid item xs={12}>
                            <OnlineOffers />
                        </Grid>
                        <Grid item xs={12}>
                            <TransactionsOffers />
                        </Grid>
                    </Grid>
                    <NavigationButtons
                        onBack={handleBack}
                        onNext={() => formikProps.handleSubmit()}
                    />
                </Box>
            )}
        </Formik>
    );
};
